<template>
  <div class="index">
    <!-- banner -->
    <slider :sliderData="sliderData"></slider>
    <!-- 部门简介 -->
    <div class="bmjj margin-t50">
      <div class="w1200">
        <div class="bmjjTitle">
          <p>部门简介</p>
          <span>DEPARTMENT PROFILE</span>
          <em></em>
        </div>
        <div class="jjBox flexDiv margin-t50">
          <p class="jjImg">
            <span class="imgBox"><img :src="bmjj.Photo" alt=""/></span>
          </p>
          <p class="details" v-html="bmjj.Info"></p>
        </div>
      </div>
    </div>
    <!-- 无图新闻（信息公告+人事政策） -->
    <div class="wutuDiv">
      <div class="w1200 flexDiv">
        <xxgg
          :xxggList="xxggList"
          moreLink="/list.html?HType=2&CId=5607"
        ></xxgg>
        <!-- <rszc :rszcList='rszcList' moreLink = "/list.html?HType=2&CId=5608"></rszc> -->
        <zcpp
          :zcppList="zcppList"
          moreLink="/list.html?HType=2&CId=5610"
        ></zcpp>
      </div>
    </div>
    <!-- 无图新闻（职称评聘+师资建设） -->
    <!-- <div class="wutuDiv2">
          <div class="w1200 flexDiv">
            <szjs :szjsList='szjsList' moreLink = "/list.html?HType=2&CId=5614"></szjs>
          </div>
        </div> -->
  </div>
</template>
<script>
import "../assets/css/index.css";
import slider from "@/components/slider";
import xxgg from "@/components/xxgg";
import rszc from "@/components/rszc";
import zcpp from "@/components/zcpp";
import szjs from "@/components/szjs";
export default {
  name: "index",
  components: {
    slider,
    xxgg,
    rszc,
    zcpp,
    szjs
  },
  data() {
    return {
      baseUrl: "this.baseUrl",
      sliderData: [],
      xxggList: [],
      rszcList: [],
      zcppList: [],
      szjsList: []
    };
  },
  created() {
    this.$root.$children["0"].$children["0"].menuListOne.forEach(
      element => (element.On = false)
    );
    this.sliderData = this.Base.GetFilesInfoByCid(5619, 1, "", 6, 1); //banner
    this.bmjj = this.Base.GetSinglePageInfoByCid(5606); //部门简介
    this.xxggList = this.Base.GetNewsInfoByCid(5607, false, 1, "", 3); //信息公告
    this.rszcList = this.Base.GetNewsInfoByCid(5608, false, 1, "", 3); //人事政策
    this.zcppList = this.Base.GetNewsInfoByCid(5610, false, 1, "", 4); //职称评聘
    this.szjsList = this.Base.GetNewsInfoByCid(5614, false, 1, "", 4);
    // console.log(this.bmjj)
    // console.log(this.bmjj.Photo)
  }
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/index.vue